import classNames from "classnames";
import { useEffect, useState } from "react";

export const useDots = (isXl?: boolean) => {
    const [labelClass, setLabelClass] = useState<string>('no-dots');

    useEffect(() => {
        const intervalId = setInterval(() => {
            setLabelClass((prev) => {
                switch (prev) {
                    case "two-dots":
                        return "three-dots";
                    case "one-dot":
                        return "two-dots";
                    case "no-dots":
                        return "one-dot";
                    default:
                        return "no-dots";
                }
            });
        }, 500);

        return () => clearInterval(intervalId);
    }, []); // Empty dependency array - only set up once

    return classNames('dot-target', labelClass, { 'dots-xl': isXl});
}
